const toCommas = (x) => !x ? 0 : x.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");

export {
    toCommas
}